exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrap-status[data-v-a3266786] {\n  text-align: center;\n}\n", ""]);

// exports
